import Vue from "vue";
import store from "@/store";
import { STATIC_HOST } from '@/api/constants'

const preUrl = STATIC_HOST
let loading = false;
let pString = "";
let allString = "";

let controller = null;
let signal = null;

export const clearController = () => {
  controller = null;
  signal = null;
};
export const setNewAbortController = async () => {
  clearController();
  // 加这玩意停不了
  // await setTimeout(() => {
  controller = new AbortController();
  signal = controller.signal;
  // }, 0);
};
export const controllerAbort = (a) => {
  if (controller) {
    if (signal?.aborted === false) {
      controller?.abort?.();
    }
  }

  clearController();
};
export const clearAllStr =  () => {
  allString = ''
  // pString = ''
}
export const greetApiStream = async () => {
  // console.warn(`🚀 ~ file: askApiStream.js:34 ~ askApiStream ~ text : ` + text + '***end');
  try {
    try {
      await setNewAbortController();
    } catch (error) {
      console.error(
        `🚀 ~ file: askGreetChat.js:647 ~ askGreetChat ~ error : `,
        error
      );
    }

    loading = true;

    const response = await fetch(preUrl + 'agent_greet_chat',
      {
        signal,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/event-stream",
          Authorization: "Bearer " + store?.state?.vuex_app_token || "",
          user_token: "Bearer " + store?.state?.vuex_app_token || "",
          'USER-TOKEN': store?.state?.appletInfo?.user_token
        },
        body: JSON.stringify({
          chat_type: 'h5'
        }),
      }).then().catch(error => {
      // 捕获异常，但不显示错误信息
      console.error('chat-stream-greet Fetch error :', error);
      if (error.name !== 'AbortError') {
        console.error('Fetch greet error:', error);
      }
      // 如果错误不是因为用户终止请求，则处理错误
    });
    //
    /* noah modify 20240409
    if (!response) {
      return Promise.reject({ msg: "无res" });
    } */
    const reader = response.body.getReader();
    console.error(
      `🚀 ~ file: askApiStream.js:73 ~ askApiStream ~ response : `, response?.status,
      response
    );
    if (response?.status !== 200) {
      let _decoder = new TextDecoder();
      let _resultData = '';
      let _result = true;
      while (_result) {
        const { done, value } = await reader.read();
        if (done) {
          console.log("500 error Stream ended");
          _result = false;
          break;
        }
        _resultData += _decoder.decode(value);
      }
      try {
        const errorBody  = JSON.parse(_resultData)
        console.log('errorBody.', errorBody)
        //console.log('errorBody.msg',errorBody.msg)
        if (response?.status === 500){
          return Promise.reject({
            msg: errorBody?.msg ? errorBody?.msg : "Greet的接口错误",//弹出系统的msg：当前账户余额不足，请充值后使用
          });
        } else {
          return Promise.reject({
            msg: response?.status ? "接口错误 " + response?.status : "Greet接口错误",//弹出系统的msg：当前账户余额不足，请充值后使用
          });
        }
      } catch (error){
        console.log('JSON.stringify(resultData) error:', error)
      }

    }
    const readStream = async () => {
      loading = false;

      while (true) {
        const { done, value } = await reader.read();

        const decoder = new TextDecoder();
        const decodedString = decoder.decode(value);
        // let str = decodedString.replace(/\r?\n/g, '$^$')
        const str = decodedString;
        // str = str.replace(/\r/, "$^R^$");
        // str = str.replace(/\n/, "$^N^$");
        // const stepStrList = ["。", "；", "！"];
        let step = false;

        // if (/\n/.test(str)) {
        //   step = true;
        // }
        // stepStrList.forEach((element) => {
        //   const pattern = new RegExp(`/${element}/`);
        //   if (pattern.test(str)) {
        //     step = element;
        //   }
        // });
        if (/。/.test(str)) {
          step = "。";
        } else if (/；/.test(str)) {
          step = "；";
        } else if (/！/.test(str)) {
          step = "！";
        }
          // else if (/./.test(str)) {
          //   step = ".";
        // }
        else if (/;/.test(str)) {
          step = ";";
        } else if (/!/.test(str)) {
          step = "!";
        }
        // .replace(/^data: \s*/g, "") // 使用全局替换（添加"g"标志）
        // .replace(/\n/g, "");
        if (done) {
          // 可能结尾有 \n
          // const str = pString.split("\n")[0];
          const str = pString.split(step)[0];
          //let str = pString.split("\n")[0];

          /* let str = pString.replace(/\n/g, "")
          str = str.split(step)[0]; */ // noah modify 删除换行 取分割符前面的
          if (str) {
            console.error("!!!!!!!!!!!!! 1 _sendMsgAnswerShowAndPlayEvent:" + str);
            Vue.prototype?.$_sendMsgAnswerShowAndPlayEventGreet(
              str,
              "数据流下载完毕 done"
            );

            pString = "";
          }

          // 回答保存进历史记录
          // console.log('判断历史的name：', name)
          if (name === 'sendMsgClick' || name === '语音识别结果'){
            let chatHistory = store?.state?.chatHistory
            let historyObject = {
              type: 'answer',
              text: allString
            }
            chatHistory.push(historyObject)

            store.commit('chatHistory', chatHistory)
          }

          console.log("数据流1下载完毕 done\n\n", allString);
          return Promise.resolve();
        }
        if (str === "[DONE]") {
          console.log("*** enter str === [DONE] \n\n", allString);
          // 可能结尾有 \n
          // const str = pString.split("\n")[0];
          const str = pString.split(step)[0];
          if (str) {
            console.error(
              "🚀 ~ file: askApiStream.js:48 ~ readStream ~ str 结尾: ",
              str
            );
            console.error("!!!!!!!!!!!!! 2 _sendMsgAnswerShowAndPlayEvent");
            Vue.prototype?.$_sendMsgAnswerShowAndPlayEventGreet(
              str,
              "数据流2下载完毕 str === DONE"
            );

            // 回答保存进历史记录
            // console.log('判断历史的name：', name)
            if (name === 'sendMsgClick' || name === '语音识别结果'){
              let chatHistory = store?.state?.chatHistory
              let historyObject = {
                type: 'answer',
                text: pString
              }
              chatHistory.push(historyObject)

              store.commit('chatHistory', chatHistory)
            }

            pString = "";
          }

          // 回答保存进历史记录
          // console.log('判断历史的name：', name)
          if (name === 'sendMsgClick' || name === '语音识别结果'){
            let chatHistory = store?.state?.chatHistory
            let historyObject = {
              type: 'answer',
              text: allString
            }
            chatHistory.push(historyObject)

            store.commit('chatHistory', chatHistory)
          }

          console.log("数据流2下载完毕 str === DONE\n\n", allString);
          return Promise.resolve();
        }
        // str = str.split("data: ");
        // let newStreamDataSSE = str && str[str.length - 1];

        const newStreamDataSSE = str;

        if (newStreamDataSSE !== "[DONE]") {
          allString += newStreamDataSSE;
          // .replace(/\n/, "$^N^$")
          // .replace(/\r/, "$^R^$");
          if (step) {
            // const strList = newStreamDataSSE.split("\n");
            const strList = newStreamDataSSE.split(step);
            // 拿第一个,补上符号
            pString += strList[0] + step;
            if (pString) {
              console.error("!!!!!!!!!!!!! 3 _sendMsgAnswerShowAndPlayEvent");
              // 反馈给tts
              // console.log('反馈给tts pString:' + pString)
              Vue.prototype?.$_sendMsgAnswerShowAndPlayEventGreet(
                pString,
                "pString"
              )
            }
            // 有可能不止一个，有好几个个\n合在一起，所以取剩下的,length-1可能就是0
            const strListLength = strList.length
            if (strList && strListLength > 1) {
              const newList = strList.slice(1, strList.length)
              pString = newList.join(step) || ''
            } else {
              pString = ''
            }
          } else {
            pString += newStreamDataSSE
          }
        }
      }
    };

    await readStream.call(this); // 使用call方法确保箭头函数中的this引用正确的Vue组件实例
    clearController();
  } catch (error) {
    clearController();
    console.error(
      `🚀 ~ file: askApiStream.js:207 ~ askApiStream ~ error :`,
      error
    );
    if (error?.toString()?.indexOf("The user aborted a request") > -1) {
      return Promise.reject({ msg: "用户中断生成", noShowToast: true });
    } else {
      /* if(error === 'TypeError: Failed to fetch'){
        console.log('TypeError: Failed to fetch')
      } */
      if (error instanceof TypeError) {
        console.log('错误类型是 TypeError'); //{var i=new Uint8Array(t.length+r.value.length)
      } else {
        return Promise.reject({ msg: "回复获取失败", noShowToast: true  });
      }

    }
  }
};
